var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1E2447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.432.022c-.987 0-1.787.79-1.787 1.766v12.187l.894-.337V1.84c0-.488.4-.927.893-.927.494 0 .894.44.894.927v11.798l.893.337V1.788c0-.975-.8-1.766-1.787-1.766z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11) translate(7.2 2.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.326 13.125v.928c.945.356 1.616 1.26 1.616 2.318 0 1.37-1.123 2.48-2.51 2.48-1.386 0-2.51-1.11-2.51-2.48 0-1.059.672-1.962 1.617-2.318v-.928c-1.446.388-2.51 1.694-2.51 3.246 0 1.858 1.524 3.364 3.403 3.364 1.88 0 3.404-1.506 3.404-3.364 0-1.552-1.064-2.858-2.51-3.246z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11) translate(7.2 2.4)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M3.525.483c0 .246-.197.445-.44.445H.447c-.243 0-.44-.2-.44-.445 0-.246.197-.445.44-.445h2.638c.243 0 .44.2.44.445z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11) translate(7.2 2.4) translate(6.032 2.496)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    d: "M3.525.483c0 .246-.197.445-.44.445H.447c-.243 0-.44-.2-.44-.445 0-.246.197-.445.44-.445h2.638c.243 0 .44.2.44.445zM2.646 2.686c0 .246-.197.445-.44.445H.446c-.242 0-.44-.2-.44-.445 0-.246.198-.445.44-.445h1.76c.243 0 .44.2.44.445zM2.646 7.092c0 .246-.197.445-.44.445H.446c-.242 0-.44-.2-.44-.445 0-.246.198-.445.44-.445h1.76c.243 0 .44.2.44.445zM3.525 4.89c0 .245-.197.444-.44.444H.447c-.243 0-.44-.2-.44-.445 0-.246.197-.445.44-.445h2.638c.243 0 .44.2.44.445zM3.525 9.295c0 .246-.197.445-.44.445H.447c-.243 0-.44-.2-.44-.445 0-.246.197-.445.44-.445h2.638c.243 0 .44.2.44.445z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11) translate(7.2 2.4) translate(6.032 2.496)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    d: "M3.868 7.927c0-.243-.191-.439-.427-.439h-.018c-.236 0-.427.196-.427.439v6.579c-.88.204-1.54 1.012-1.54 1.977 0 1.119.886 2.029 1.976 2.029 1.09 0 1.976-.91 1.976-2.029 0-.965-.66-1.773-1.54-1.977v-6.58z",
    transform: "translate(-747 -895) translate(732 884) translate(15 11) translate(7.2 2.4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureM);
export default __webpack_public_path__ + "static/media/temperature-m.552bbceb.svg";
export { ForwardRef as ReactComponent };